import PlatformService from './service';

const service = new PlatformService();

export default service;
